<div class="root noselect">

  <section id="filter" *ngIf="exibirPesquisa">
    <div id="left-side">
      <h1>Pedidos</h1>

      <!-- <span>Mostrar: </span> -->

      <!-- <div [class.active]="pedidoService.filtroExibicao !== 'Todos'" id="filter-container" [matMenuTriggerFor]="perfil">
        {{pedidoService.filtroExibicao}} <mat-icon>expand_more</mat-icon></div>
      <mat-menu #perfil="matMenu">
        <button mat-menu-item *ngIf="pedidoService.filtroExibicao !== 'Todos'"
          (click)="pedidoService.filtroExibicao = 'Todos'">Todos</button>
        <button mat-menu-item *ngIf="pedidoService.filtroExibicao !== 'Atrasados'"
          (click)="pedidoService.filtroExibicao = 'Atrasados'">Atrasados</button>
        <button mat-menu-item *ngIf="pedidoService.filtroExibicao !== 'Entrega'"
          (click)="pedidoService.filtroExibicao = 'Entrega'">Entrega</button>
        <button mat-menu-item *ngIf="pedidoService.filtroExibicao !== 'Retirada'"
          (click)="pedidoService.filtroExibicao = 'Retirada'">Retirada</button>
        <button mat-menu-item *ngIf="pedidoService.filtroExibicao !== 'Consumo'"
          (click)="pedidoService.filtroExibicao = 'Consumo'">Consumo Local</button>
      </mat-menu> -->

      <!-- <div class="flagDeConfirmacao">
        <span>Confirmação:</span>
        <mat-select placeholder="Manual" [(value)]="kanbanService.modoConfirmacaoPedido">
          <mat-option value="M" selected>Manual</mat-option>
          <mat-option value="A">Automático</mat-option>
        </mat-select>
      </div> -->

    </div>

    <div id="right-side">
      <div id="pesquisar">
        <mat-form-field appearance="outline" color="light">
          <mat-label>Buscar</mat-label>
          <input [(ngModel)]="pedidoService.filtroBusca" matInput type="text">
          <button *ngIf="!!pedidoService.filtroBusca" mat-icon-button matSuffix (click)="pedidoService.filtroBusca = ''"
            [attr.aria-label]="'Hide password'">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div id="mais-opcoes">
        <button mat-button [matMenuTriggerFor]="maisOpcoes">
          <span>Mais Opções</span>
          <mat-icon class="mat-18">expand_more</mat-icon>
        </button>
        <mat-menu #maisOpcoes="matMenu" xPosition="before">
          <button mat-menu-item (click)="limparMonitor()">
            <mat-icon class="mat-18">border_clear</mat-icon> <span>Limpar Monitor</span>
          </button>
          <button mat-menu-item (click)="getPedidosDoDia()">
            <mat-icon class="mat-18">today</mat-icon> <span>Pedidos do Dia</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </section>


  <section id="filtro-pedido">
    <button mat-button id="btn-toggle-search" (click)="toogleExibirPesquisa()">
      <mat-icon fontSet="material-icons-outlined" class="mat-18">{{ exibirPesquisa ? 'expand_less' : 'expand_more'
        }}</mat-icon>
    </button>

    <app-botao-filtro-pedido *ngFor="let botao of kanbanService.filtros"
      [configuracao]="botao"></app-botao-filtro-pedido>
  </section>

  <div class="board" cdkScrollable>
    <div class="board-wrapper">
      <div class="board-columns" cdkDropListGroup>
        <div *ngFor="let grupo of kanbanService.gruposOrdenados; let idx = index; trackBy: trackByColumn">


          <div class="board-column" [class.destacado]="grupo.listaEstaDestacada"
            *ngIf="[1,2,3,4].includes(grupo.numeroDoStatus) ||  grupo.quantidadeDeItens > 0"
            id="pedidos-status-{{grupo.status}}">

            <div class="column-title">
              <span class="color-status-{{grupo.status}}">{{grupo.nome}}
                <small>({{ grupo.quantidadeDeItens }})</small></span>
              <div>
                <button [class.visible]="grupo.status != '6' && grupo.itens?.length > 0 && exibirOpcoesDaColuna"
                  class="colum-more-options" [matMenuTriggerFor]="opcoes" mat-icon-button
                  aria-label="Example icon button with a vertical three dot icon">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #opcoes="matMenu" xPosition="before">
                  <button *ngIf="grupo.status < 4" mat-menu-item (click)="kanbanService.avancarTodosDoGrupo(grupo)">
                    <mat-icon class="mat-18">arrow_forward</mat-icon> <span>Avançar Todos</span>
                  </button>
                  <button *ngIf="grupo.status > 1 && grupo.status < 5" mat-menu-item
                    (click)="kanbanService.voltarTodosDoGrupo(grupo)">
                    <mat-icon class="mat-18">arrow_back</mat-icon> <span>Voltar Todos</span>
                  </button>
                  <button *ngIf="[4,5].includes(grupo.numeroDoStatus)" mat-menu-item (click)="limparGrupo(grupo)">
                    <mat-icon class="mat-18">border_clear</mat-icon> <span>Limpar Coluna</span>
                  </button>
                </mat-menu>
              </div>
            </div>

            <div class="tasks-container" cdkDropList [cdkDropListData]="grupo"
              (cdkDropListDropped)="onCdkDropListDropped($event)"
              (cdkDropListEntered)="onDropListEntered($event, grupo)"
              (cdkDropListExited)="onDropListExited($event, grupo)" (cdkDropListDropped)="afterDropEvent($event)"
              (cdkDropListEnded)="onDragEnded($event)" autoScrollDisabled="true" autoScrollStep="200"
              cdkDropListAutoScrollStep="10">

              <ng-container *ngFor="let order of grupo.itens; trackBy: trackByItem">
                <div class="cdk-drag" *ngIf="kanbanService.pedidoPassouNoFiltro(order)" cdkDrag [cdkDragData]="order"
                  [cdkDragStartDelay]="this.appService.cardDragDelayInMilisenconds" longPress
                  (mouseLongPress)="mouseLongPress($event)" (click)="onClickKanbanCard($event)"
                  (mouseup)="onMouseUpKanbanCard($event)" (touchend)="onTouchEndKanbanCard($event)"
                  (cdkDragEnded)="cdkDragEnded($event, grupo)" [class.efeito-transicao]="order.efeitoTransicaoAtivo"
                  [class.atualizando]="order.estaAtualizandoNoServidor"
                  [cdkDragDisabled]="order.estaAtualizandoNoServidor">

                  <!-- <div class="custom-placeholder" *cdkDragPlaceholder></div> -->

                  <div [class.cancelado]="order.pedido.status == 5 " class="task"
                    *ngIf="order | filtroExibicaoPedido:pedidoService.filtroExibicao:pedidoService.filtroBusca"
                    id={{order.pedido.id}}>
                    <div class="headerPedido">
                      <p class="info-nome">{{order.pedido.Pedido.Nome}}</p>
                      <ng-container *ngIf="order?.pedido?.Pedido?.DadosAgendamento && [1,2,3].includes(grupo.status) ">
                        <span [class.visible]="grupo.itens?.length > 0 && exibirOpcoesDaColuna"
                          class="colum-more-options options-pedido-agendado"
                          [matMenuTriggerFor]="opcoesPedidoAgendado"><mat-icon>more_horiz</mat-icon></span>
                        <mat-menu #opcoesPedidoAgendado="matMenu" xPosition="before">
                          <button mat-menu-item (click)="kanbanService.voltarPedidoParaStatusAgendado(order)">
                            <span>Voltar Para Agendado</span>
                          </button>
                        </mat-menu>
                      </ng-container>
                    </div>

                    <div class="bodyPedido">
                      <div class="info-id">
                        <span>#{{order.pedido.id}}</span> - <span>{{order.pedido.DataHora | date: 'HH:mm'}}</span>
                      </div>

                      <div class="endereco flex-space-between" *ngIf="order.pedido.Pedido.OpcaoEntrega === 'E'">
                        <div>
                          <mat-icon>location_on</mat-icon>
                          <div>{{order.pedido.Pedido.Rua}} - {{order.pedido.Pedido.Numero}} -
                            {{order.pedido.Pedido.Bairro}}</div>
                        </div>
                        <mat-icon *ngIf="!!order?.pedido.Pedido?.DadosAgendamento"
                          class="icon-agendamento">event</mat-icon>
                      </div>

                      <div class="retirar-local flex-space-between" *ngIf="order.pedido.Pedido.OpcaoEntrega === 'R'">
                        <div>
                          <mat-icon fontSet="material-icons-outlined">directions_run</mat-icon>
                          <div>Retirar no Local</div>
                        </div>
                        <mat-icon *ngIf="!!order?.pedido?.Pedido?.DadosAgendamento"
                          class="icon-agendamento">event</mat-icon>
                      </div>

                      <div class="retirar-local" *ngIf="order.pedido.Pedido.OpcaoEntrega === 'L'">
                        <mat-icon fontSet="material-icons-outlined">restaurant</mat-icon>
                        <div>
                          <p>Consumir Local - <b>Mesa {{order.pedido.Pedido.Mesa}}</b></p>
                        </div>
                      </div>

                      <ng-container *ngIf="order.pedido.Pedido.OpcaoEntrega === 'C'">
                        <div class="retirar-local">
                          <mat-icon fontSet="material-icons-outlined">restaurant</mat-icon>
                          <div>
                            <p>Consumir Local - <b>Comanda {{order.pedido.Pedido.Comanda}}</b></p>
                          </div>
                        </div>
                        <p class="fsz-12">Entregar em: <b>{{order.pedido.Pedido.ComandaLocal}}</b></p>
                      </ng-container>

                      <div class="dados-agendamento" *ngIf="order?.pedido?.Pedido?.DadosAgendamento">
                        <p class="header-text">Pedido Agendado para</p>
                        <p>{{order?.pedido?.Pedido?.DadosAgendamento?.Dia}} -
                          {{order?.pedido?.Pedido?.DadosAgendamento?.Hora}}</p>
                      </div>

                      <div class="progresso">
                        <mat-progress-bar [class]="order.pedido.Progresso | colorProgress" mode="determinate"
                          value="{{order.pedido.Progresso}}"></mat-progress-bar>
                      </div>

                      <div class="botoes-acao">
                        <mat-icon title="Cancelar pedido" *ngIf="order.pedido.status < 4"
                          (click)="cancelarPedido(order, grupo.status)">block</mat-icon>
                        <div title="Enviar mensagem via whatsapp"><img src="assets/img/whatsapp.svg"
                            (click)="chamarNumero(order)" alt=""></div>
                        <mat-icon title="Visualizar Pedido" (click)="visualizarPedido(order)">printer</mat-icon>

                        <a *ngIf="!order?.pedido?.Pedido?.DadosAgendamento || order.pedido.status != 1"
                          class="acao-avancar" mat-flat-button
                          (click)="kanbanService.movimentarItemAutomaticamente(order, grupo.status, order.acaoProximoStatus.status)">
                          {{ order.acaoProximoStatus.acao }}
                        </a>

                        <a *ngIf="!!order?.pedido?.Pedido?.DadosAgendamento && order.pedido.status == 1"
                          class="acao-avancar" mat-flat-button
                          (click)="kanbanService.movimentarItemAutomaticamente(order, grupo.status, 6)">
                          Confirmar Ag.
                        </a>

                        <a title="Não exibir mais o pedido no monitor" *ngIf="[4,5].includes(grupo.numeroDoStatus)"
                          class="acao-avancar" mat-flat-button
                          (click)="kanbanService.setarPedidoParaNaoExibirMaisNoMonitor(order)">
                          Limpar
                        </a>

                      </div>
                      <i class="fa fa-arrow-right gray fs-16 fa-1x"></i>
                    </div>
                  </div> <!-- Task -->
                </div>
              </ng-container>

            </div> <!-- Tasks Container -->
          </div>

        </div> <!-- Board Column -->
      </div> <!-- Board Columns -->
    </div> <!-- Board Wrapper -->
  </div> <!-- Board -->
</div> <!-- Root -->